// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:\"light\";src:url(\"/fonts/Poppins-Light.ttf\") format(\"truetype\")}@font-face{font-family:\"regular\";src:url(\"/fonts/Poppins-Regular.ttf\") format(\"truetype\")}@font-face{font-family:\"bold\";src:url(\"/fonts/Poppins-SemiBold.ttf\") format(\"truetype\")}.policy-container{width:98%;max-width:1440px;text-align:left;margin:20px auto}.policy-container h2{margin-top:30px}.policy-container h3{margin:40px auto 20px}.policy-container li{margin:30px auto}", ""]);
// Exports
module.exports = exports;
